<template>
    <div>
        <div v-if="selectedCustomReport != null" class="router-header flex flex-wrap items-center mb-6">
            <div class="content-area__heading">
                <h2 class="mb-1">{{ selectedCustomReport.reportName }}</h2>
            </div>
        </div>
        <!-- <page-breadcrumb title="Graph" :routes="routes" /> -->
        <div class="flex items-center justify-between mb-4">
            <div v-if="breadcrumb != null">
                <div class="orgs" v-if="$route.name != 'custom_report_view'">
                    <ul class="brdcrmb">
                        <li v-if="isBreadCrumbSite"><router-link :to="breadcrumb.site.link">{{ breadcrumb.site.title
                        }}</router-link></li>
                        <li v-if="isBreadCrumbArea"><router-link :to="breadcrumb.area.link">{{ breadcrumb.area.title
                        }}</router-link></li>
                        <li v-if="isBreadCrumbCamera"><router-link :to="breadcrumb.camera.link">{{ breadcrumb.camera.title
                        }}</router-link></li>
                    </ul>
                </div>
            </div>
        </div>
        <vx-card>

            <div class="flex items-center space-x-2">
                <div style="min-width:250px">
                    <v-select disabled label="name" placeholder="Site" class="w-full" v-model="site" :options="siteLists"></v-select>
                </div>
                <div style="min-width:200px">
                    <v-select disabled label="eventName" placeholder="Select event" class="w-full" v-model="event"
                        :options="eventLists"></v-select>
                </div>
                <div style="min-width:200px">
                    <v-select :disabled="disableSearch" placeholder="Select date" class="w-full" v-model="dateSelected"
                        :options="dateSelectLists"></v-select>
                </div>
                <div style="min-width:200px" v-if="dateSelected.code == 'today'">
                    <v-select :disabled="disableSearch" placeholder="Select time range" class="w-full" v-model="timerange"
                        :options="timerangeLists"></v-select>
                </div>
                <div v-if="dateSelected.code != 'today'">
                    <date-picker :disabled="disableSearch" placeholder="Select datetime range" v-model="daterange"
                        type="date" range format="DD/MM/YYYY" :disabled-date="notAferToday"></date-picker>
                </div>
                <div v-if="!disableSearch" class="flex-grow flex justify-end">
                    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-search"
                        @click.prevent="buildReport">Build Report</vs-button>
                </div>
            </div>

        </vx-card>

        <div class="mb-4">&nbsp;</div>

        <summary-card :data="summaryData"></summary-card>

        <vx-card v-if="showReport && lists.length > 0">
            <counting-chart :lists="lists" />
        </vx-card>

        <vx-card v-else>
            <div class="flex flex-col items-center text-center">
                <img style="width:300px" src="@/assets/images/icon/icon-grafik.png" />
                <h3>Silahkan pilih tanggal</h3>
            </div>
        </vx-card>

        <div class="mb-4">&nbsp;</div>

        <vx-card v-if="showReport && showBottomLists">
            <report-bottom-lists :title="bottomTitle" :next="nextLink" :datas="statisticsData"></report-bottom-lists>
        </vx-card>

    </div>
</template>

<script>
import moment from 'moment';
import vSelect from "vue-select";
import DatePicker from 'vue2-datepicker';
import api from '@/api'
import ReportBottomLists from "./custom_report_bottom.vue";
import StatisticBox from "../reports/components/StatisticBox.vue";
import OccupancyChart from "../reports/components/OccupancyChart.vue";
import CountingChart from "../reports/components/CountingChart.vue";
import SummaryCard from "../reports/components/SummaryCard.vue";

import 'vue2-datepicker/index.css';

export default {
    data() {
        return {
            breadcrumb: null,
            daterange: '',
            site: '',
            event: '',
            eventLists: [],
            detail: null,
            siteLists: [],
            timerange: '1 hour',
            timerangeLists: [
                { code: "1 hour", label: "1 hour" },
                { code: "3 hours", label: "3 hours" },
                { code: "6 hours", label: "6 hours" },
                { code: "12 hours", label: "12 hours" },
                { code: "24 hours", label: "24 hours" },
            ],
            dateSelected: { code: "today", label: "Today" },
            dateSelectLists: [
                { code: "today", label: "Today" },
                { code: "other", label: "Select Date" },
            ],
            disabledDateAfter: new Date(),
            showReport: false,
            lists: [],
            statisticsData: [],
            bottomTitle: '',
            nextLink: '',
            isBreadCrumbSite: true,
            isBreadCrumbArea: true,
            isBreadCrumbCamera: true,
            disableSearch: false,
            showBottomLists: true,
            searchQuery: "",
            selectedCustomReport: null
        }
    },
    components: {
        DatePicker,
        vSelect,
        ReportBottomLists,
        StatisticBox,
        OccupancyChart,
        CountingChart,
        SummaryCard
    },
    computed: {
        summaryData() {
            if (this.lists.length > 0) {
                return this.lists[0].chart.series[0].data
            }
            return []
        }
    },
    beforeMount() {
        this.breadcrumb = JSON.parse(localStorage.getItem('reportBreadcrumb'));

        const selectedCustomReportStore = localStorage.getItem('selectedCustomReport')
        const selectedCustomReport = JSON.parse(selectedCustomReportStore)
        console.log(selectedCustomReport)
        if(selectedCustomReport != null && selectedCustomReport != undefined && selectedCustomReport != '') {
            this.selectedCustomReport = selectedCustomReport
        }

        this.checkRoute()
    },
    mounted() {
        this.getSiteLists()
        this.getEventLists()
        console.log("route_name")
        console.log(this.$route.name)
        if (this.$route.name != 'custom_report_view') {
            this.getChartData()
            this.getReportData()
        }
    },
    methods: {
        checkRoute() {
            const reportSearch = localStorage.getItem('reportSearch')
            const reportSearchParsed = JSON.parse(reportSearch)
            if(reportSearchParsed != undefined && reportSearchParsed != null && reportSearchParsed != '') {
                this.site = reportSearchParsed.site != undefined ? reportSearchParsed.site : ''
                this.event = reportSearchParsed.event != undefined ? reportSearchParsed.event : ''
                this.dateSelected = reportSearchParsed.dateSelected != undefined ? reportSearchParsed.dateSelected : { code: "today", label: "Today" }
                this.timerange = reportSearchParsed.timerange != undefined ? reportSearchParsed.timerange : '1 hour'
                this.startdate = reportSearchParsed.startdate != undefined ? reportSearchParsed.startdate : ''
                this.enddate = reportSearchParsed.enddate != undefined ? reportSearchParsed.enddate : ''

                if(this.dateSelected.code == 'other') {
                    this.daterange = [
                        new Date(this.startdate),
                        new Date(this.enddate)
                    ]
                }
            }

            if (this.$route.name != 'custom_report_view') {
                this.showReport = true
                this.disableSearch = true
            }

            this.isBreadCrumbHome = true;
            this.isBreadCrumbSite = true;
            this.isBreadCrumbArea = false;
            this.isBreadCrumbCamera = false;

            this.bottomTitle = 'Camera Lists'
            this.apiReportDetailCsv = '/ReportDetail/download/site'
            this.reportModel = {
                customReportId: this.$route.params.id
            }
            this.chartModel = {
                siteId: this.site.id,
                rangeParam: this.timerange.code,
                customReportId: this.$route.params.id
            }

            // switch (this.$route.name) {
            //     case 'custom_report_area':
            //         this.isBreadCrumbHome = true;
            //         this.isBreadCrumbSite = true;
            //         this.isBreadCrumbArea = true;
            //         this.isBreadCrumbCamera = false;

            //         this.bottomTitle = 'Camera'
            //         this.nextLink = '/custom_report/camera'
            //         this.apiReportPath = '/Avigilon/dashboard/area'
            //         this.apiReportDetailCsv = '/ReportDetail/download/area'
            //         this.reportModel = {
            //             areaId: this.$route.params.id
            //         }
            //         this.chartModel = {
            //             siteId: this.site.id,
            //             areaId: this.$route.params.id,
            //             customReportId: this.selectedCustomReport.id,
            //             rangeParam: this.timerange.code,
            //         }
            //         if (this.dateSelected.code != 'today') {
            //             this.chartModel = {
            //                 siteId: this.site.id,
            //                 areaId: this.$route.params.id,
            //                 customReportId: this.selectedCustomReport.id,
            //                 startdate: this.startdate,
            //                 enddate: this.enddate
            //             }
            //         }
            //         break;
            //     case 'custom_report_camera':
            //         this.isBreadCrumbHome = true;
            //         this.isBreadCrumbSite = true;
            //         this.isBreadCrumbArea = true;
            //         this.isBreadCrumbCamera = true;

            //         this.showBottomLists = false
            //         this.bottomTitle = ''
            //         this.nextLink = ''
            //         this.apiReportPath = '/Avigilon/dashboard/camera'
            //         this.apiReportDetailCsv = '/ReportDetail/download/camera'
            //         this.reportModel = {
            //             cameraId: this.$route.params.id
            //         }
            //         this.chartModel = {
            //             siteId: this.site.id,
            //             areaId: this.area,
            //             cameraId: this.$route.params.id,
            //             customReportId: this.selectedCustomReport.id,
            //             rangeParam: this.timerange.code,
            //         }
            //         if (this.dateSelected.code != 'today') {
            //             this.chartModel = {
            //                 siteId: this.site.id,
            //                 areaId: this.area,
            //                 cameraId: this.$route.params.id,
            //                 customReportId: this.selectedCustomReport.id,
            //                 startdate: this.startdate,
            //                 enddate: this.enddate
            //             }
            //         }
            //         break;
            //     default:
            //         this.isBreadCrumbHome = true;
            //         this.isBreadCrumbSite = true;
            //         this.isBreadCrumbArea = false;
            //         this.isBreadCrumbCamera = false;

            //         this.bottomTitle = 'Area'
            //         this.nextLink = '/custom_report/area'
            //         this.apiReportPath = 'getCameraCustomReportSelection'
            //         this.apiReportDetailCsv = '/ReportDetail/download/site'
            //         this.reportModel = {
            //             siteId: this.site.id
            //         }
            //         this.chartModel = {
            //             siteId: this.site.id,
            //             rangeParam: this.timerange.code
            //         }
            // }
        },
        buildReport() {
            this.showReport = true
            
            if (this.dateSelected.code == 'today') {
                this.chartModel = {
                    siteId: this.site.id,
                    rangeParam: this.timerange.code,
                    customReportId: this.$route.params.id
                }
            } else {
                const rawStartMonth = this.daterange[0].getMonth() + 1
                const startMonth = rawStartMonth.toString().padStart(2, '0')
                const startDate = this.daterange[0].getDate().toString().padStart(2, '0')

                const rawEndMonth = this.daterange[1].getMonth() + 1
                const endMonth = rawEndMonth.toString().padStart(2, '0')
                const endDate = this.daterange[1].getDate().toString().padStart(2, '0')

                this.chartModel = {
                    siteId: this.site.id,
                    customReportId: this.$route.params.id,
                    startdate: `${this.daterange[0].getFullYear()}-${startMonth}-${startDate}`,
                    enddate: `${this.daterange[1].getFullYear()}-${endMonth}-${endDate}`
                }
            }

            this.getChartData()
            this.getReportData()
        },
        notAferToday(date) {
            return date > new Date(new Date().setHours(23, 59, 0, 0));
        },
        openCustomReport() {
            this.$router.push('/custom_report')
        },
        getSiteLists() {
            if (this.$store.state.sites.length > 0) {
                this.siteLists = this.$store.state.sites
            } else {
                this.$vs.loading()
                api.sites({
                    siteName: this.searchQuery
                })
                    .then(result => result.data)
                    .then(data => {
                        if (data.status) {
                            this.siteLists = data.data
                        }
                        this.$vs.loading.close()
                    })
                    .catch((e) => {
                        console.log(e)
                        this.$vs.loading.close()
                    });
            }
        },
        getEventLists() {
            if (this.$store.state.events.length > 0) {
                this.eventLists = this.$store.state.events
                if (this.selectedCustomReport != null && this.selectedCustomReport != undefined) {
                    const filteredEventLists = this.eventLists.filter(item => item.id == this.selectedCustomReport.parameterEventId)
                    this.event = filteredEventLists[0]
                }
            } else {
                this.$vs.loading()
                api.getEventLists()
                    .then(result => result.data)
                    .then(data => {
                        if (data.status) {
                            this.eventLists = data.data
                            this.$store.dispatch('updateEventLists', data.data)

                            if (this.selectedCustomReport != null && this.selectedCustomReport != undefined) {
                                const filteredEventLists = this.eventLists.filter(item => item.id == this.selectedCustomReport.parameterEventId)
                                this.event = filteredEventLists[0]
                            }
                        }
                        this.$vs.loading.close()
                    })
                    .catch((e) => {
                        console.log(e)
                        this.$vs.loading.close()
                    });
            }
        },
        downloadCsvDailyReport(params) {
            // GET /api/ReportDetail/download/site?siteId=3&startDate=2022-09-24&endDate=2022-09-26
            this.$vs.loading()

            const qParams = {
                ...this.reportModel,
                startDate: moment(params.start).format('YYYY-MM-DD'),
                endDate: moment(params.end).format('YYYY-MM-DD')
            }

            console.log(qParams)

            api.reportData(this.apiReportDetailCsv, qParams)
                .then(result => result.data)
                .then(data => {
                    let itemsFormatted = [];

                    let nameLabel = ''
                    if (this.apiReportDetailCsv.includes('site')) {
                        nameLabel = 'Site Name'
                    }
                    if (this.apiReportDetailCsv.includes('area')) {
                        nameLabel = 'Area Name'
                    }
                    if (this.apiReportDetailCsv.includes('camera')) {
                        nameLabel = 'Camera Name'
                    }

                    var headers = {
                        name: nameLabel,
                        inPersom: 'IN_Person',
                        inCar: 'IN_Car',
                        inMotor: 'IN_Motorcycle',
                        inOther: 'IN_OtherVehicle',
                        inTotal: 'Total_IN',
                        outPersom: 'OUT_Person',
                        outCar: 'OUT_Car',
                        outMotor: 'OUT_Motorcycle',
                        outOther: 'OUT_OtherVehicle',
                        outTotal: 'Total_OUT',
                        date: 'Date'
                    };

                    if (data.status) {
                        const rData = data.data

                        rData.forEach((item) => {
                            let name = ''
                            if (this.apiReportDetailCsv.includes('site')) {
                                name = item.siteName
                            }
                            if (this.apiReportDetailCsv.includes('area')) {
                                name = item.areaName
                            }
                            if (this.apiReportDetailCsv.includes('camera')) {
                                name = item.cameraName
                            }

                            itemsFormatted.push({
                                name: name.replace(/,/g, ''), // remove commas to avoid errors,
                                inPersom: item.inPerson,
                                inCar: item.inCar,
                                inMotor: item.inMotorcycle,
                                inOther: item.inOtherVehicle,
                                inTotal: item.totalIn,
                                outPersom: item.outPerson,
                                outCar: item.outCar,
                                outMotor: item.outMotorcycle,
                                outOther: item.outOtherVehicle,
                                outTotal: item.totalOut,
                                date: item.date
                            });
                        });

                        const now = Date.now();
                        var fileTitle = 'report-' + now; // or 'my-unique-title'

                        this.$vs.loading.close()
                        this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
                    }
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
        getChartData() {
            this.$vs.loading()
            api.getCustomReportGrafik(this.chartModel)
            .then((result) => result.data)
            .then(data => {
                console.log(data)
                this.lists = data.data
                this.showReport = true
                this.$vs.loading.close()
            })
            .catch((e) => {
                console.log(e)
                this.$vs.loading.close()
            });
        },
        getReportData() {
            api.getCameraCustomReportSelection(this.reportModel)
                .then(result => result.data)
                .then(data => {
                    if (data.status) {
                        this.statisticsData = data.data
                    }
                    this.$vs.loading.close()
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.orgs {
    font-size: 16px;

    span {
        color: #1372ac;
        font-weight: 600;
    }

    padding-bottom: 20px;
}

.title {
    text-align: center;
    font-size: 18pt;
    font-weight: 700;
}

.brdcrmb {
    text-transform: capitalize;
    font-weight: 600;
    display: flex;
    color: #1372AC;

    li {
        a {
            text-transform: capitalize;
            color: #1372AC;
            padding: 0 10px;

        }

        &:first-child {
            a {
                padding-left: 0 !important;
                padding-right: 10px;
            }
        }

        &::after {
            content: "/";
        }

        &:last-child {
            &::after {
                content: "";
            }
        }
    }
}
</style>
